module.exports = __webpack_public_path__ + "static/media/baseline-local_dining-24px.e842d0a5.svg";